export const DEFAULT_INITIAL_CHANNEL_PAGE_SIZE = 25;
export const DEFAULT_NEXT_CHANNEL_PAGE_SIZE = 100;
export const DEFAULT_THREAD_PAGE_SIZE = 50;
